var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImmersiveGameDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5753 100.26C64.5747 100.26 68.5942 100.08 72.5837 100.32C75.1333 100.47 77.313 101.891 79.1528 103.682C81.0725 105.553 82.8723 107.554 84.892 109.295C85.7419 110.025 87.0217 110.615 88.1216 110.635C96.0405 110.745 103.949 110.755 111.868 110.635C113.008 110.615 114.328 109.965 115.228 109.205C117.138 107.584 118.798 105.683 120.597 103.932C123.317 101.28 126.566 99.9497 130.386 99.9698C135.955 100.01 141.534 100.09 147.104 99.9497C155.043 99.7496 161.172 103.161 166.031 109.165C170.971 115.268 173.47 122.442 174.48 130.116C175.74 139.621 174.79 148.916 170.831 157.751C168.251 163.514 164.601 168.436 159.152 171.818C150.533 177.161 140.735 175.68 133.216 167.956C129.326 163.964 126.806 159.231 125.067 153.939C124.257 151.457 122.967 149.026 121.427 146.905C119.357 144.063 116.348 142.753 112.718 142.793C104.749 142.873 96.7804 142.813 88.8015 142.813C81.6625 142.813 77.2131 146.024 75.1833 152.938C73.5835 158.371 71.1739 163.304 67.2544 167.446C57.3957 177.851 43.7875 177.401 34.5587 166.375C29.3594 160.162 26.6098 152.878 25.5499 144.964C24.1901 134.808 25.31 124.943 29.8494 115.638C32.469 110.275 36.0985 105.753 41.3678 102.731C44.5674 100.9 48.0069 99.9297 51.7165 99.9597C54.6661 99.9798 57.6257 99.9597 60.5753 99.9597C60.5753 100.05 60.5753 100.14 60.5753 100.24V100.26ZM51.8164 132.127C51.8164 134.718 51.7065 137.16 51.8764 139.591C51.9464 140.531 52.4464 141.662 53.1363 142.282C53.6262 142.733 55.026 142.843 55.5359 142.452C56.3058 141.862 57.0357 140.751 57.1157 139.811C57.3257 137.29 57.1857 134.738 57.1857 132.127C59.9354 132.127 62.455 132.257 64.9347 132.057C65.8346 131.987 66.9644 131.316 67.4544 130.566C67.8443 129.966 67.7443 128.565 67.2744 128.015C66.6845 127.324 65.5146 126.874 64.5647 126.814C62.1451 126.654 59.7154 126.764 57.1857 126.764C57.1857 124.043 57.2357 121.541 57.1757 119.04C57.1157 116.739 55.176 115.428 53.3362 116.389C52.1464 117.009 51.8164 118.069 51.8264 119.32C51.8464 121.751 51.8264 124.183 51.8264 126.754C49.2568 126.754 46.8671 126.744 44.4874 126.754C42.4177 126.774 41.1279 127.825 41.1379 129.445C41.1479 131.066 42.4377 132.097 44.5174 132.107C46.8971 132.127 49.2768 132.107 51.8264 132.107L51.8164 132.127ZM142.884 110.695C140.055 110.655 137.515 113.147 137.485 115.988C137.445 118.83 139.925 121.361 142.774 121.401C145.604 121.441 148.144 118.96 148.184 116.098C148.224 113.257 145.744 110.725 142.894 110.685L142.884 110.695ZM137.475 126.794C137.495 123.943 135.015 121.431 132.156 121.411C129.316 121.391 126.796 123.883 126.776 126.734C126.756 129.586 129.236 132.097 132.096 132.117C134.935 132.137 137.455 129.646 137.475 126.794ZM158.892 126.724C158.862 123.862 156.353 121.381 153.503 121.411C150.653 121.441 148.164 123.963 148.194 126.804C148.224 129.666 150.743 132.147 153.583 132.117C156.432 132.087 158.922 129.566 158.892 126.724ZM142.774 142.833C145.604 142.873 148.144 140.391 148.184 137.54C148.224 134.698 145.744 132.167 142.894 132.127C140.065 132.087 137.525 134.578 137.485 137.42C137.445 140.261 139.915 142.793 142.774 142.833Z",
    fill: "url(#paint0_linear_68_570)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2235 94.5273H46.6171C46.4771 92.5963 46.4371 90.6553 46.1872 88.7542C45.5972 84.2318 43.3275 80.6699 39.868 77.7284C36.8984 75.207 33.8488 72.7257 31.2691 69.8442C26.9897 65.0516 25.21 59.2285 25.02 52.7951C24.82 45.9414 26.1598 39.628 30.3893 34.0851C33.4788 30.0429 37.4183 27.1414 42.1877 25.3604C44.8673 24.3599 46.4571 25.4505 46.4571 28.292C46.4571 34.2652 46.4871 40.2284 46.4371 46.2015C46.4371 47.2321 46.7471 47.7724 47.647 48.2827C55.8259 52.8351 63.9648 52.8251 72.1337 48.2426C72.9636 47.7824 73.2735 47.2521 73.2735 46.2916C73.2235 40.3184 73.2435 34.3552 73.2535 28.382C73.2535 25.4305 74.8233 24.3499 77.603 25.3804C87.8316 29.1725 94.4907 38.8776 94.6907 49.8535C94.8107 56.6271 93.8308 63.0705 89.5214 68.4434C87.0717 71.495 84.1821 74.3265 81.0825 76.7078C75.7032 80.85 73.0236 86.0628 73.2435 92.8164C73.2635 93.3567 73.2435 93.897 73.2435 94.5173L73.2235 94.5273Z",
    fill: "url(#paint1_linear_68_570)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.375 94.5369H126.866V54.3755C130.326 55.306 133.776 56.2365 137.375 57.207V94.5369Z",
    fill: "url(#paint2_linear_68_570)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.964 57.197C146.564 56.2265 149.973 55.306 153.433 54.3755V94.5169H142.964V57.197Z",
    fill: "url(#paint3_linear_68_570)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.233 48.6825C144.054 52.8248 136.165 52.8448 128.086 48.6625C129.766 44.7905 131.406 41.0385 133.026 37.2865C134.555 33.7646 135.985 30.2127 137.655 26.7609C138.035 25.9704 139.195 25.15 140.025 25.11C140.855 25.0699 142.174 25.8003 142.504 26.5407C145.814 33.8146 148.954 41.1685 152.223 48.6825H152.233Z",
    fill: "url(#paint4_linear_68_570)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_68_570",
    x1: 100.005,
    y1: 99.9414,
    x2: 100.005,
    y2: 174.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_68_570",
    x1: 59.8505,
    y1: 24.9966,
    x2: 59.8505,
    y2: 94.5273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_68_570",
    x1: 132.121,
    y1: 54.3755,
    x2: 132.121,
    y2: 94.5369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_68_570",
    x1: 148.199,
    y1: 54.3755,
    x2: 148.199,
    y2: 94.5169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_68_570",
    x1: 140.16,
    y1: 25.1084,
    x2: 140.16,
    y2: 51.7942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmersiveGameDesign);
export default __webpack_public_path__ + "static/media/Immersive_Game_Design.8b878eb6e0238150fdb542c0da3d5a86.svg";
export { ForwardRef as ReactComponent };